import { LogsService } from '@gtpl/shared-services/user-logs';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { LevelAdapter } from './dto/level.adapter';
import { LevelController } from './level.controller';
import { Level } from './level.entity';
import { LevelService } from './level.service';

@Module({
  imports: [
    TypeOrmModule.forFeature([Level]),
  ],
  controllers: [LevelController],
  providers: [LevelService,LevelAdapter,ApplicationExceptionHandler,LogsService]
})
export class LevelModule {}
